import { Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../context/AuthContext";
import { LogoHorizontal } from "./Logo";

export function PublicHeader() {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-3 sm:px-6 h-24 flex items-center justify-between gap-2 sm:gap-3">
        <Link to="/" aria-label="DentiCision home" className="shrink-0"><LogoHorizontal size={66} className="max-[420px]:!h-11" /></Link>
        <nav className="flex items-center gap-0.5 sm:gap-2 min-w-0">
          <Link to="/guides" data-testid="header-guides-link" className="hidden sm:inline-flex px-3 py-2 text-sm font-medium text-slate-700 hover:text-[#1C6FE3]">Clinical Guides</Link>
          <Link to="/pricing" data-testid="header-pricing-link" className="inline-flex px-1 min-[421px]:px-1.5 sm:px-3 py-2 text-[11px] min-[421px]:text-xs sm:text-sm font-semibold text-slate-700 hover:text-[#1C6FE3]">Pricing</Link>
          <Link to="/institutions" data-testid="header-clinics-link" className="inline-flex px-1 min-[421px]:px-1.5 sm:px-3 py-2 text-[11px] min-[421px]:text-xs sm:text-sm font-semibold sm:font-medium text-slate-700 hover:text-[#1C6FE3] whitespace-nowrap">For Clinics</Link>
          {user ? (
            <Link to="/app"><Button data-testid="go-app-btn" className="bg-[#0B2545] hover:bg-[#0B2545]/90">Open app <ArrowRight className="w-4 h-4 ml-1.5" /></Button></Link>
          ) : (
            <>
              <Link to="/login"><Button variant="ghost" data-testid="header-login-btn" className="text-slate-700 px-1 min-[421px]:px-1.5 sm:px-4 text-[11px] min-[421px]:text-xs sm:text-sm">Sign in</Button></Link>
              <Link to="/register"><Button data-testid="header-register-btn" className="bg-[#0B2545] hover:bg-[#0B2545]/90 px-2 min-[421px]:px-2.5 sm:px-4 text-[11px] min-[421px]:text-xs sm:text-sm">Get started</Button></Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="bg-[#0B2545] py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
        <div className="flex justify-center">
          <div className="bg-white rounded-2xl px-6 py-4 inline-flex shadow-sm">
            <LogoHorizontal size={54} />
          </div>
        </div>
        <p className="text-slate-200 font-semibold mt-4">DentiCision™ · Clinical Decision Support for Dentistry</p>
        <p className="text-slate-400 text-sm mt-1 max-w-2xl mx-auto">An evidence-based second opinion to assist dentists — it does not replace professional clinical judgment or consultation with the patient's physician.</p>
        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-5 text-sm">
          <Link to="/guides" data-testid="footer-guides-link" className="text-slate-300 hover:text-white">Clinical Guides</Link>
          <Link to="/pricing" data-testid="footer-pricing-link" className="text-slate-300 hover:text-white">Pricing</Link>
          <Link to="/register" className="text-slate-300 hover:text-white">Start free trial</Link>
          <Link to="/contact" data-testid="footer-contact-link" className="text-slate-300 hover:text-white">Contact</Link>
          <Link to="/login" className="text-slate-300 hover:text-white">Sign in</Link>
          <a href="mailto:denticision@gmail.com" data-testid="footer-email-link" className="text-slate-300 hover:text-white">denticision@gmail.com</a>
          <a href="https://www.youtube.com/@denticision" target="_blank" rel="noopener noreferrer me" data-testid="footer-youtube-link" aria-label="DentiCision on YouTube"
            className="inline-flex items-center gap-1.5 text-slate-300 hover:text-red-400 transition-colors"><Youtube className="w-4 h-4" /> YouTube</a>
        </nav>
        <nav className="flex flex-wrap justify-center gap-x-5 gap-y-2 mt-4 text-xs">
          <Link to="/terms" data-testid="footer-terms-link" className="text-slate-400 hover:text-white">Terms of Service</Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="text-slate-400 hover:text-white">Privacy Policy</Link>
          <Link to="/refund-policy" data-testid="footer-refund-link" className="text-slate-400 hover:text-white">Cancellation & Refund Policy</Link>
          <Link to="/medical-disclaimer" data-testid="footer-disclaimer-link" className="text-slate-400 hover:text-white">Medical Disclaimer</Link>
          <Link to="/clinical-agreement" data-testid="footer-clinical-agreement-link" className="text-slate-400 hover:text-white">Clinical Use Agreement</Link>
        </nav>
        <p className="text-slate-500 text-xs mt-5">© {new Date().getFullYear()} DentiCision. All rights reserved.</p>
      </div>
    </footer>
  );
}
